export default {
  /**
   * 是否空对象
   *
   * @param {object | number | string} obj 是否空对象/数值/...
   * @returns {boolean} 是否为空
   */
  isEmptyObject(obj) {
    for (let name in obj) {
      return false
    }

    if (typeof obj === 'number' || typeof obj === 'boolean') return false // 如果是数值 或者布尔值，都不能认为是空
    return true
  },
  /**
   * 对象是否相同
   * 只比较值，不比较引用
   *
   * @param {object} a 对象
   * @param {object} b 对象
   * @returns {boolean} 相同
   */
  isEqual(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a)
    var bProps = Object.getOwnPropertyNames(b)

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
      return false
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i]

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true
  }
}
